import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewMomDetails from "./viewMomDetails";
import {
    getMomBymeetingId
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    momBymeetingId: state.baMeetingReducer.momBymeetingId,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ getMomBymeetingId }, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(ViewMomDetails);
